import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=06ee0f19&scoped=true&"
import script from "./GalleryModal.vue?vue&type=script&lang=js&"
export * from "./GalleryModal.vue?vue&type=script&lang=js&"
import style0 from "./GalleryModal.vue?vue&type=style&index=0&id=06ee0f19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee0f19",
  null
  
)

export default component.exports